/**
 * Crop-code classification for FVM Marker features.
 * The same set is used by the jordprisberegner pipeline (`jpb-jordprisberegnerDB` markClasses).
 * Fields whose Afgkode is in this set are taget ud af omdrift (permanent grass and similar).
 * Unknown or missing Afgkode stays in omdrift.
 */

export const NON_ROTATION_CROP_CODES = new Set([
   "250", "251", "252", "254", "255", "256", "257", "259", "271", "272", "274", "276", "278", "279", "286",
   "287", "311", "316", "318", "319", "321", "322", "326", "361", "363", "401", "482", "485", "487", "488",
   "489", "490", "491", "492", "493", "494", "495", "496", "497", "499", "504", "505", "506", "507", "508",
   "509", "512", "514", "515", "516", "517", "518", "519", "520", "521", "522", "523", "524", "525", "526",
   "527", "528", "529", "530", "531", "532", "533", "534", "535", "536", "537", "538", "539", "545", "563",
   "564", "565", "566", "567", "570", "575", "576", "577", "578", "580", "581", "582", "583", "585", "586",
   "587", "589", "590", "591", "592", "593", "594", "596", "597", "900", "903", "907",
]);

const CROP_CODE_PROPERTY_CANDIDATES = [
   "Afgkode",
   "AfgKode",
   "afgkode",
   "afgroedekode",
   "afgrødekode",
   "cropCode",
];

function getPropertyCaseInsensitive(properties: Record<string, unknown>, key: string): unknown {
   const direct = properties[key];
   if (direct !== undefined) return direct;
   const lowerKey = key.toLowerCase();
   const realKey = Object.keys(properties).find((propertyKey) => propertyKey.toLowerCase() === lowerKey);
   return realKey ? properties[realKey] : undefined;
}

function getFirstPropertyCaseInsensitive(properties: Record<string, unknown>, keys: string[]): unknown {
   for (const key of keys) {
      const value = getPropertyCaseInsensitive(properties, key);
      if (value !== undefined && value !== null && value !== "") return value;
   }
   return undefined;
}

export function getCropCode(feature: { properties?: Record<string, unknown> | null } | null | undefined): string | null {
   const properties = feature?.properties ?? {};
   const value = getFirstPropertyCaseInsensitive(properties, CROP_CODE_PROPERTY_CANDIDATES);
   if (value === undefined) return null;
   const match = String(value).trim().match(/\d+/);
   return match ? String(Number(match[0])) : null;
}

export function isFieldOutsideRotation(feature: { properties?: Record<string, unknown> | null } | null | undefined): boolean {
   const cropCode = getCropCode(feature);
   return cropCode !== null && NON_ROTATION_CROP_CODES.has(cropCode);
}
